import { createStyles, Table, Text, Paper } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.colors.orange[2]}`,
    backgroundColor: theme.colors.orange[0],
    overflow: "hidden",
  },
  header: {
    backgroundColor: theme.colors.orange[1],
    paddingTop: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    borderBottom: `1px solid ${theme.colors.orange[2]}`,
  },
  headerText: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 600,
    color: theme.colors.gray[8],
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    lineHeight: 1.5,
  },
  table: {
    "& td": {
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
      paddingLeft: theme.spacing.md,
      paddingRight: theme.spacing.md,
    },
    "& tr:first-of-type td": {
      paddingTop: theme.spacing.md,
    },
    "& tr:last-of-type td": {
      paddingBottom: theme.spacing.md,
    },
  },
  label: {
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
  },
  value: {
    color: theme.colors.gray[8],
    fontSize: theme.fontSizes.sm,
    fontWeight: 600,
    textAlign: "right",
  },
  note: {
    marginTop: theme.spacing.sm,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[6],
    fontStyle: "italic",
  },
  noteInPaper: {
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[7],
    fontStyle: "italic",
    fontWeight: 500,
  },
}));

export default function ProductPricing({ pricing, note, title = "價格" }) {
  const { classes } = useStyles();
  const rows = pricing?.length ? pricing : [];
  if (!rows.length && !note) return null;

  return (
    <div>
      <Paper className={classes.paper} radius="md" shadow="xs" p={0}>
        <div className={classes.header}>
          <Text className={classes.headerText}>{title}</Text>
        </div>
        {rows.length > 0 ? (
          <Table className={classes.table} verticalSpacing="md" horizontalSpacing="md">
            <tbody>
              {rows.map((row) => (
                <tr key={row.label || row.value}>
                  {row.label ? (
                    <>
                      <td className={classes.label}>{row.label}</td>
                      <td className={classes.value}>{row.value}</td>
                    </>
                  ) : (
                    <td colSpan={2} className={classes.value}>
                      {row.value}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <Text className={classes.noteInPaper} px="md" py="md" style={{ textAlign: "center" }}>
            {note}
          </Text>
        )}
      </Paper>
      {rows.length > 0 && note && <Text className={classes.note}>{note}</Text>}
    </div>
  );
}
